import React from "react";
import PropTypes from "prop-types";

class DisplayAddress extends React.PureComponent {
  renderPhoneNumber() {
    if (this.props.address.phoneNumber.length) {
      let areaCode = this.props.address.phoneNumber.substring(0, 3);
      let firstPart = this.props.address.phoneNumber.substring(3, 6);
      let secondPart = this.props.address.phoneNumber.substring(6);

      return `(${areaCode}) ${firstPart}-${secondPart}`;
    }
    return null;
  }

  renderAddress() {
    let street = "";
    if (this.props.address) {
      street = this.props.address.street;
      if (!street) {
        street = this.props.address.street1;

        if (this.props.address.street2 && this.props.address.street2 !== "") {
          street += "\n" + this.props.address.street2;
        }
        if (this.props.address.street3 && this.props.address.street3 !== "") {
          street += "\n" + this.props.address.street3;
        }
      }
    }
    let name = this.props.address.businessName
      ? this.props.address.businessName
      : this.props.address.name;

    return (
      <div>
        {this.props.address && (
          <React.Fragment>
            {name && (
              <div>
                <span className="font-weight-bold">{name}</span>
              </div>
            )}
            <div>
              <span>{street}</span>
            </div>
            <div>
              <span>
                {this.props.address.city}, {this.props.address.state}{" "}
                {this.props.address.zipCode}
              </span>
            </div>
            {this.props.displayFullAddress && (
              <React.Fragment>
                {this.props.address.attention && (
                  <div>
                    <span>Attn: {this.props.address.attention}</span>
                  </div>
                )}
                <div>
                  <span>{this.renderPhoneNumber()}</span>
                </div>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }

  render() {
    return this.renderAddress();
  }
}

DisplayAddress.propTypes = {
  address: PropTypes.object,
  displayFullAddress: PropTypes.bool,
};

export default DisplayAddress;
